module.exports = __webpack_public_path__ + "img/prioritas_sameday_dfod_dg.83b00960.png";